import React, { useEffect, useRef, useState } from "react";
import filter from "../../../../Assets/Images/Configuration/filter-icon.svg";
import Filter_MonthDowRoomTypeRatePlanChannels_With_Year from "./Models/Filter_MonthDowRoomTypeRatePlanChannels_With_Year";
import { Button, Overlay, OverlayTrigger, Popover, Row, Table, Form, Col } from "react-bootstrap";
import Comments from "../Comments/Comment";
import RNXAnalysis2_BookingPace from "./RNXAnalysis2_BookingPace";
import RNXAnalysis2_RateBand from "./RNXAnalysis2_RateBand";
import RNXAnalysis2_RatePaceGraph from "./RNXAnalysis2_RatePaceGraph";
import RNXAnalysis2_RevenuAdrNight from "./RNXAnalysis2_RevenuAdrNight";
import RNXAnalysis2_RevenueVolumeByChannels from "./RNXAnalysis2_RevenueVolumeByChannels";
import RNXAnalysis2_RoomNightRateBand from "./RNXAnalysis2_RoomNightRateBand";
import RNXAnalysis2_RoomNightVolumeByChannels from "./RNXAnalysis2_RoomNightVolumeByChannels";
import horizobtalBarIcon from "../../../../Assets/Images/Revenue-management/horizontal-bars.svg";
import graphIcon from "../../../../Assets/Images/Revenue-management/graphIcon.svg";
import horizobtalBarIconInActive from "../../../../Assets/Images/Revenue-management/horizontal-bars-inactive.svg";
import graphIconInActive from "../../../../Assets/Images/Revenue-management/graphIcon-inactive.svg";
import { commonService } from "../../../../utils/commonService";


const RNXAnalysis2 = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {

    const [filterData, setFilterData] = useState({ year: new Date().getFullYear(), months: [], dow: [], ratecodes: [], roomtypes: [], combinedchannels: [] });

    const [viewOption, setViewOption] = useState("Graph");

    const [DisplayFilter, setDisplayFilter] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });

    const CloseFilter = (data) => {
        setDisplayFilter({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
        setFilterData(data)
    };

    const ShowFilter = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setDisplayFilter({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };
    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
        id2: commonService.GenerateGUID(),
        id3: commonService.GenerateGUID(),
        id4: commonService.GenerateGUID(),
    });

    return (
        <>
            <Row>
                <div class="filter-bar">
                    {
                        filterData.months && filterData.months.length > 0 &&
                        <div class="filter-chip" title={filterData.months.map(m => m.name).join(" , ")}>
                            <span>Month : {filterData.months[0].name} <b>{filterData.months.length > 1 ? `+${filterData.months.length - 1}` : ""}</b></span>
                            <span id={commonService.generateGlobalClickTrackerID("RNXAnalysis2", "span-onclick", "")} class="btn-close" onClick={
                                (e) => setFilterData((prev) => ({
                                    ...prev,
                                    months: [],
                                }))}></span>
                        </div>
                    }
                    {
                        filterData.dow && filterData.dow.length > 0 &&
                        <div class="filter-chip" title={filterData.dow.map(m => m.name).join(" , ")}>
                            <span>DOW : {filterData.dow[0].name} <b>{filterData.dow.length > 1 ? `+${filterData.dow.length - 1}` : ""}</b></span>
                            <span id={commonService.generateGlobalClickTrackerID("RNXAnalysis2", "span-onclick", "")} class="btn-close" onClick={
                                (e) => setFilterData((prev) => ({
                                    ...prev,
                                    dow: [],
                                }))}></span>
                        </div>
                    }
                    {
                        filterData.ratecodes && filterData.ratecodes.length > 0 &&
                        <div class="filter-chip" title={filterData.ratecodes.map(m => m.name).join(" , ")}>
                            <span>Rate Code : {filterData.ratecodes[0].name} <b>{filterData.ratecodes.length > 1 ? `+${filterData.ratecodes.length - 1}` : ""}</b></span>
                            <span id={commonService.generateGlobalClickTrackerID("RNXAnalysis2", "span-onclick", "")} class="btn-close" onClick={
                                (e) => setFilterData((prev) => ({
                                    ...prev,
                                    ratecodes: [],
                                }))}></span>
                        </div>
                    }
                    {
                        filterData.roomtypes && filterData.roomtypes.length > 0 &&
                        <div class="filter-chip" title={filterData.roomtypes.map(m => m.name).join(" , ")}>
                            <span>Room Type : {filterData.roomtypes[0].name} <b>{filterData.roomtypes.length > 1 ? `+${filterData.roomtypes.length - 1}` : ""}</b></span>
                            <span id={commonService.generateGlobalClickTrackerID("RNXAnalysis2", "span-onclick", "")} class="btn-close" onClick={
                                (e) => setFilterData((prev) => ({
                                    ...prev,
                                    roomtypes: [],
                                }))}></span>
                        </div>
                    }
                    {
                        filterData.combinedchannels && filterData.combinedchannels.length > 0 &&
                        <div class="filter-chip" title={filterData.combinedchannels.map(m => m.name).join(" , ")}>
                            <span>Channels : {filterData.combinedchannels[0].name} <b>{filterData.combinedchannels.length > 1 ? `+${filterData.combinedchannels.length - 1}` : ""}</b></span>
                            <span id={commonService.generateGlobalClickTrackerID("RNXAnalysis2", "span-onclick", "")} class="btn-close" onClick={
                                (e) => setFilterData((prev) => ({
                                    ...prev,
                                    combinedchannels: [],
                                }))}></span>
                        </div>
                    }

                    <button id={commonService.generateGlobalClickTrackerID("RNXAnalysis2", "button-onclick", "")} class="filter-button" aria-label="Filter" onClick={(e) => { ShowFilter(e); }}>
                        <img src={filter} alt="Filter" />
                    </button>
                    <div id={commonService.generateGlobalClickTrackerID("RNXAnalysis2", "div-onclick", "")} className="TableGraphContainer" onClick={(e) => { setViewOption(viewOption === "Table" ? "Graph" : "Table"); }}>
                        <button class={`filter-button TableGraph ${viewOption === "Table" ? 'active' : ''}`} aria-label="Filter" >
                            <img src={viewOption === "Table" ? horizobtalBarIcon : horizobtalBarIconInActive} alt="Table" />
                        </button>
                        <button class={`filter-button TableGraph ${viewOption === "Graph" ? 'active' : ''}`} aria-label="Graph">
                            <img src={viewOption === "Graph" ? graphIcon : graphIconInActive} alt="Graph" />
                        </button>
                    </div>
                </div>
            </Row>

            <Row className={"mt-4"}>
                <RNXAnalysis2_RevenuAdrNight
                    setCompDataFromChild={setCompDataFromChild}
                    rowIndex={rowIndex}
                    colIndex={colIndex}
                    api={api}
                    para={para}
                    setting={setting}
                    topfilterdata={filterData}
                    topviewoption={viewOption}
                />
            </Row>
            <Row className={"mt-5"}>
                <Col xl={6}>
                    <RNXAnalysis2_RevenueVolumeByChannels
                        setCompDataFromChild={setCompDataFromChild}
                        rowIndex={rowIndex}
                        colIndex={colIndex}
                        api={api}
                        para={para}
                        setting={setting}
                        topfilterdata={filterData}
                        topviewoption={viewOption}
                    />
                </Col>
                <Col xl={6}>
                    <RNXAnalysis2_RoomNightVolumeByChannels
                        setCompDataFromChild={setCompDataFromChild}
                        rowIndex={rowIndex}
                        colIndex={colIndex}
                        api={api}
                        para={para}
                        setting={setting}
                        topfilterdata={filterData}
                        topviewoption={viewOption}
                    />
                </Col>
            </Row>

            <Row className={"mt-5"}>
                <Col xl={6}>
                    <RNXAnalysis2_RateBand
                        setCompDataFromChild={setCompDataFromChild}
                        rowIndex={rowIndex}
                        colIndex={colIndex}
                        api={api}
                        para={para}
                        setting={setting}
                        topfilterdata={filterData}
                        topviewoption={viewOption}
                    />
                </Col>
                <Col xl={6}>
                    <RNXAnalysis2_RoomNightRateBand
                        setCompDataFromChild={setCompDataFromChild}
                        rowIndex={rowIndex}
                        colIndex={colIndex}
                        api={api}
                        para={para}
                        setting={setting}
                        topfilterdata={filterData}
                        topviewoption={viewOption}
                    />
                </Col>
            </Row>

            <Row className={"mt-5"}>
                <RNXAnalysis2_BookingPace
                    setCompDataFromChild={setCompDataFromChild}
                    rowIndex={rowIndex}
                    colIndex={colIndex}
                    api={api}
                    para={para}
                    setting={setting}
                    topfilterdata={filterData}
                    topviewoption={viewOption}
                />
            </Row>

            <Row className={"mt-5"}>
                <RNXAnalysis2_RatePaceGraph
                    setCompDataFromChild={setCompDataFromChild}
                    rowIndex={rowIndex}
                    colIndex={colIndex}
                    api={api}
                    para={para}
                    setting={setting}
                    topfilterdata={filterData}
                    topviewoption={viewOption}
                />
            </Row>

            {api !== 0 && (
                <Comments widgetDetails={para} editorId={"editor" + tblids.id1} />
            )}


            {
                DisplayFilter.IsDisplay &&
                <Overlay
                    show={DisplayFilter.IsDisplay}
                    target={DisplayFilter.Target}
                    placement={DisplayFilter.Position}
                >
                    <Popover
                        id="popover-contained"
                        className="FilterPopover"
                    >
                        <Filter_MonthDowRoomTypeRatePlanChannels_With_Year show={DisplayFilter.IsDisplay} closeModal={CloseFilter} para={para} dropdownSelectedData={filterData} />
                    </Popover>
                </Overlay>
            }
        </>
    );
};

export default RNXAnalysis2;
